type ThankYouSettings = {
  thankYouTemplate?: string
} | undefined

const MESSAGE_DRIVEN_TEMPLATE_IDS = new Set(['18forty', 'generic', 'ncsy'])

export function getTemplateIdFromPath(path: string) {
  return path.split('/').pop()?.replace(/\.[^.]+$/, '') || ''
}

export function findTemplateModuleKey<T>(
  modules: Record<string, T>,
  templateId: string
) {
  return Object.keys(modules).find(path => getTemplateIdFromPath(path) === templateId)
}

export function resolveThankYouTemplateId(
  formId: string | undefined,
  settings: ThankYouSettings,
  availableTemplatePaths: string[]
) {
  if (settings?.thankYouTemplate) {
    return settings.thankYouTemplate
  }

  if (
    formId &&
    availableTemplatePaths.some(path => getTemplateIdFromPath(path) === formId)
  ) {
    return formId
  }

  return 'generic'
}

export function thankYouTemplateUsesMessage(templateId: string) {
  return MESSAGE_DRIVEN_TEMPLATE_IDS.has(templateId)
}

export function toThankYouComponentName(templateId: string) {
  return `${templateId}-thank-you`
}
